<template>
    <div class="Page">
        <!--Video Section-->
        <div class="videoContainer">
            <video width="100%" controls autoplay muted>
                <source src="../../public/ressources/images/video/LandingPage.mp4" type="video/mp4">
                Votre navigateur ne prend pas en charge la lecture de la vidéo.
            </video>
        </div>
        <div style="margin-top: -6px;" class="orangeStripe"></div>
        <div id="SecondeBloc" class="BGBloc2">
                <div class="grid grid-pad">
                    <div class="contenu">
                        <v-row>
                            <v-col cols="12"><h2 class="truckTitle">Nos Camions</h2></v-col>
                            <v-col cols="12"><h2 class="emissionTitle">Zéro Émission</h2></v-col>
                        </v-row>
                        <v-row >
                            <v-col class="truck" cols="12" md="4">
                                <div class="blocImg">
                                    <img src="../../public/ressources/images/truckElectrik/truck1.png" />
                                </div>
                                <h2>Poids léger</h2>
                                <button><a href="https://isuzucv.com/en/nseries/nseries_ev" target="_blank">Isuzu<br>Série N</a></button>
                            </v-col>
                            <v-col class="truck" cols="12" md="4">
                                <div class="blocImg">
                                    <img src="../../public/ressources/images/truckElectrik/truck2.png" />
                                </div>
                                <h2>Poids moyen</h2>
                                <button><a href="https://www.internationaltrucks.com/zero-emissions" target="_blank">International<br>eMV</a></button>
                            </v-col>
                            <v-col class="truck" cols="12" md="4">
                                <div class="blocImg">
                                    <img src="../../public/ressources/images/truckElectrik/truck3.png" />
                                </div>
                                <h2>Poids lourd</h2>
                                <button><a href="https://battlemotors.com/pages/let-ii-ev-specs" target="_blank">Battle Motors<br>LNT & LET</a></button>
                            </v-col>
                        </v-row>
                    </div>
                </div>
        </div>
        <div class="orangeStripe"></div>
        <div id="ThirdBloc" class="BGBloc3">
                <div class="grid grid-pad">
                    <v-row class="contenu">
                        <v-row>
                            <v-col cols="12"><h2 class="txt-c Bloc3Title" style="">Planifiez une rencontre</h2></v-col>
                            <v-col cols="12"><p class="electrikText">Laissez notre équipe d'experts faire de votre transition énergétique une réussite en commerçant par</p></v-col>
                        </v-row>
                        <v-row class="iconBox">
                            <v-col cols="12" md="3" class="boxPad" > 
                                <div class="box">
                                    <div class="boximg">
                                        <img src="../../public/ressources/images/truckElectrik/icon1.png" />
                                    </div>
                                    <div class="textBox">
                                        <h3 class="title"><i>L'analyse de vos opérations</i></h3>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="3" class="boxPad" > 
                                <div class="box">
                                    <div class="boximg">
                                        <img src="../../public/ressources/images/truckElectrik/icon2.png" />                                      
                                    </div>
                                    <div class="textBox">
                                        <h3 class="title"><i>L'extraction de vos données télématiques</i></h3>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="3" class="boxPad"> 
                                <div class="box">
                                    <div class="boximg">
                                        <img src="../../public/ressources/images/truckElectrik/icon3.png" />                                       
                                    </div>
                                    <div class="textBox">
                                       <h3 class="title"><i>La planification de vos infrastructures de recharge</i></h3>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="3" class="boxPad"> 
                                <div class="box">
                                    <div class="boximg">
                                        <img src="../../public/ressources/images/truckElectrik/icon4.png" />  
                                    </div>
                                    <div class="textBox">
                                        <h3 class="title"><i>L'identification du bon véhicule pour votre application</i></h3>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-row>
                </div>
            <div class="blueBox"></div>
        </div>
        <form ref="formElectrik" role="form" method="POST" action="https://reseaudynamique.com/ressources/api/emails.php" @submit.prevent="validateAndSubmit"> <!-- method="POST" action="/<?php echo $NOMPAGE; ?>" -->
            <input type="hidden" id="emailId" name="emailId" value="3"> 
            <v-row id="fourthBloc" class=" BGBloc4">
                <v-col cols="12"><p class="electrikText">Électrifiez-vous dès maintenant en nous laissant vos coordonnées</p></v-col> 
                <v-row class="grid boxForm form">
                    <v-col cols="12" md="6" class="inputForm"> 
                        <input name="prenom" id="prenom" type="text" placeholder="Nom complet" class=""  v-model="form.prenom" required>  
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm"> 
                        <input name="telephone" id="telephone" type="tel" placeholder="(514) 555-1234" class="" v-model="form.telephone" @input="formatTelephone" required>
                        <p v-if="errors.telephone" class="errorMsg">{{ errors.telephone }}</p>
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm"> 
                        <input name="email" id="email" type="email" placeholder="Courriel" class="" v-model="form.email" required>
                        <p v-if="errors.email" class="errorMsg">{{ errors.email }}</p>
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm"> 
                        <input name="compagnie" id="compagnie" type="text" placeholder="Nom de l'entreprise" class="" v-model="form.compagnie" required> 
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm"> 
                        <input name="VilleEntreprise" id="VilleEntreprise" type="text" placeholder="Ville de votre entreprise" class="" v-model="form.town" required>
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm"> 
                        <select name="succursale" id="succursale" v-model="form.succursale" class="" required>
                            <option value="" disabled>Choisissez votre succursale</option>
                            <option v-for="(dealer, key) in dealers" :key="key" :value="dealer.town + ' - ' + dealer.name">{{ dealer.town }} - {{ dealer.name }}</option>
                        </select>
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm"> 
                        <select name="truckChoice" id="truckChoice" v-model="form.truckChoice" class="" required>
                            <option value="" disabled>Choisissez votre camion</option>
                            <option value="Isuzu Série N">Isuzu Série N</option>
                            <option value="International eMV">International eMV</option>
                            <option value="Battle Motors LNT & LET">Battle Motors LNT & LET</option>
                        </select>
                    </v-col>
                    <v-col cols="12" md="6" class="inputForm">
                        <input name="comment" id="comment" type="text" placeholder="Commentaire" class="" v-model="form.comment" >
                    </v-col>
                </v-row>
                <button type="submit" name="btnSendMail" id="btnSendMail" value="Envoyer" style=""><a>Soumettre</a></button>
                <h2 v-if="sendForm == true" class="electrikText">Votre demande a bien été envoyée</h2>
            </v-row>
        </form>
        <div class="bandeOrange"></div>
    </div>
  </template>
  <style scoped>
    /*Region truck Transition*/
    .BGBloc2 { height: 100%; padding: 20px 0px; background-image: url('../../public/ressources/images/truckElectrik/Bloc2BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
    #SecondeBloc .truckTitle { font-family: TxtOffBDI; font-size: 36px; text-transform: uppercase; color: #fff; text-align: right; margin: 0px;}
    #SecondeBloc .emissionTitle { font-family: TxtOffBDI; color: rgb(var(--primary)); font-size: 64px; text-transform: uppercase; text-align: right; margin: -15px 0px 0px 0px; }
    .truck button { margin-top:40px; padding: 10px; margin-right: auto; margin-left: auto; display: block; min-width: 200px; background-color: rgb(var(--secondary)); font-weight: 100; }
    .truck button a { color: #FFF; }
    .truck button:hover {box-shadow: 0px 0px 10px rgb(var(--primary)); cursor: pointer;}
    #SecondeBloc .blocImg { height: auto; max-width: 100%; margin-left: auto; margin-right: auto; }
    .blocImg img { width: 100%; height: auto; }
    .truck h2 { margin-top:10px; color: #FFF; font-weight: 400; text-align: center; }
    /*#endregion */
    /*Region section 3*/
        .BGBloc3 {position:relative;  height: 100%; padding: 100px 0px 0px 0px; background-image: url('../../public/ressources/images/truckElectrik/bloc3BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
        #ThirdBloc .title {text-transform: uppercase;  margin-top: 20px; text-align: center; font-weight: 700; font-size: 18px; margin-left: auto; margin-right: auto; display: block;}
        #ThirdBloc .box {min-height: 300px; background-color: rgb(241,241,241); border-radius: 10%; padding:10px; }
        .boximg { height: auto; max-width: 50%; margin-left: auto; margin-right: auto;  }
        .boximg img { width: 100%; height: auto; }
        .textBox { height: auto; max-width: 75%; margin-left: auto; margin-right: auto;  }
        #ThirdBloc .boxPad {padding: 0px 25px;}
        #ThirdBloc .blueBox { height: 200px; background-color: rgb(var(--secondary)); position: relative; bottom: 0; z-index: 0; margin-top: -8%;  }
        #ThirdBloc .iconBox { margin-top:10px; position: relative; z-index: 50; }
        #ThirdBloc .Bloc3Title {color: #fff; font-size: 74px; margin-top: 0px; margin-bottom: 0px; font-weight: 900;  text-transform: uppercase;}

        .electrikText { text-align: center; color: #fff; padding: 20px 0px; font-size: 24px; font-weight: 100; line-height: normal;}

    /*#endregion */
    .BGBloc4 {position:relative;  height: 100%; padding: 10px 0px 10px 0px; background-image: url('../../public/ressources/images/truckElectrik/bloc3BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
    .boxForm { padding: 0px 350px; }
    .realization { padding: 25px 0px; }
    .form input { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
    .form select { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
    .form .v-text-field input { color: white; background-color: rgba(17,17,17,1) !important; padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
    .inputForm { padding: 20px; }
    #ElectrikPage a {text-decoration: none; color:white;}
    #fourthBloc { padding: 100px 0px !important; }
    #fourthBloc button { margin-top:40px; margin-right: auto; margin-left: auto; font-size:24px; display: block; min-width: 200px; padding:20px; background-color: rgb(var(--secondary)); font-weight: 700; text-transform: uppercase; }
    #fourthBloc button a { color: #FFF; font-family: TxtOffBDI; }
    #fourthBloc button:hover {box-shadow: 0px 0px 10px rgb(var(--primary)); cursor: pointer;}
    .errorMsg { color: rgb(var(--primary)); font-size: 14px; font-family: TxtOffRe; margin-top: 5px; padding-left: 0px; }
    .form input.invalid, .form select.invalid { border: 1px solid rgb(var(--primary)) !important; }
    @media handheld, only screen and (max-width: 600px) {}
    @media handheld, only screen and (max-width: 960px) {
        h2 { font-size: 24px !important; }
        #ThirdBloc .box { margin: 20px 0px; }
        #ThirdBloc .boxPad {padding: 0px 10px;}
        .boxForm { padding: 0px 20px !important; }
        .form input { width: 100%; }
        .form select { width: 100%; }
        .boximg {max-width: 150px;}
    }
    @media handheld, only screen and (max-width: 1279px) {
        
    }
    @media handheld, only screen and (max-width: 1378px) {
        .boxForm { padding: 0px 100px; }
    }
  </style>
  <script>
  
  export default {
    name: 'TruckElectrik',
    data:()=>({
        dealers: null,
        sendForm: null, // send, error, pending
        envoiEnCours: false,
        errors: {
            telephone: '',
            email: '',
        },
        form: {
            prenom: '',
            fleetSize: '',
            function: '',
            truckChoice: '',
            compagnie: '',
            telephone: '',
            town: '',
            email: '',
            comment: '',
            succursale: '',
        }
    }),
    mounted() {
      this.dealersJsonRead();
    },
    methods:{
      /** Lecture du JSON des concessionnaires */
      dealersJsonRead: async function () {
          try {
              const response = await fetch('/ressources/json/dealers.json');
              if (!response.ok) { throw new Error('Failed to fetch'); }
              this.dealers = await response.json();
          } catch (error) {
              console.error('Error loading dealers JSON:', error);
          }
      },
      /** Formate le téléphone en (XXX) XXX-XXXX et bloque les non-chiffres */
      formatTelephone: function(e) {
          let digits = this.form.telephone.replace(/\D/g, '');
          if (digits.length > 10) { digits = digits.substring(0, 10); }
          let formatted = '';
          if (digits.length > 0) { formatted = '(' + digits.substring(0, 3); }
          if (digits.length >= 3) { formatted += ') '; }
          if (digits.length > 3) { formatted += digits.substring(3, 6); }
          if (digits.length >= 6) { formatted += '-'; }
          if (digits.length > 6) { formatted += digits.substring(6, 10); }
          this.form.telephone = formatted;
          this.errors.telephone = '';
      },
      /** Valide le format du courriel */
      validateEmail: function() {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!this.form.email) {
              this.errors.email = 'Le courriel est requis.';
              return false;
          }
          if (!regex.test(this.form.email)) {
              this.errors.email = 'Le format du courriel est invalide.';
              return false;
          }
          this.errors.email = '';
          return true;
      },
      /** Valide le téléphone (10 chiffres avec indicatif régional) */
      validateTelephone: function() {
          const digits = this.form.telephone.replace(/\D/g, '');
          if (!digits) {
              this.errors.telephone = 'Le numéro de téléphone est requis.';
              return false;
          }
          if (digits.length < 10) {
              this.errors.telephone = 'Le numéro doit contenir 10 chiffres (indicatif régional inclus).';
              return false;
          }
          this.errors.telephone = '';
          return true;
      },
      /** Valide tout le formulaire avant soumission */
      validateAndSubmit: function() {
          const telValid = this.validateTelephone();
          const emailValid = this.validateEmail();
          if (telValid && emailValid) {
              if (this.envoiEnCours) return
              this.envoiEnCours = true
              try {
                  window.fbq?.('track', 'Lead', { content_name: 'camion-electrique' })
              } catch (e) { /* le tracking ne doit jamais bloquer l'envoi */ }
              setTimeout(() => this.$refs.formElectrik.submit(), 300)
              setTimeout(() => { this.envoiEnCours = false }, 5000)
          }
      },
    },
    components: { }
  }
  </script>
  